import { BaseApiModel } from './BaseApiModel';

export class CftvVideo extends BaseApiModel {
  public urlCurrent: string;
  public type: string;
}
